import { gql } from "@apollo/client";

export const RESTORE_PRUNED_CLIP = gql`
  mutation DepruneClip($clipIdentifier: String) {
    depruneClip(clipIdentifier: $clipIdentifier)
  }
`;
